module.exports = __webpack_public_path__ + "static/media/woxware.356ae204.jpg";